import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useParams, useLocation, useNavigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Tool from './pages/Tool';
import Legal from './pages/Legal';
import { translations } from './data/translations';

function LanguageWrapper() {
  const { lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Validate language, default to 'en'
  const currentLang = translations[lang] ? lang : 'en';

  // If path doesn't have a valid language prefix, redirect to /en + current path
  useEffect(() => {
    if (!translations[lang]) {
      const pathParts = location.pathname.split('/').filter(Boolean);
      // Check if first part is a known lang but not the current one
      if (pathParts[0] && translations[pathParts[0]]) {
        // Already handled by route match, but just in case
      } else {
        navigate(`/en${location.pathname}`, { replace: true });
      }
    }
  }, [lang, navigate, location.pathname]);

  const setLang = (newLang) => {
    const pathParts = location.pathname.split('/').filter(Boolean);
    pathParts[0] = newLang; // Replace lang prefix
    navigate(`/${pathParts.join('/')}${location.search}`, { replace: true });
  };

  return (
    <Layout lang={currentLang} setLang={setLang}>
      <Routes>
        <Route index element={<Home lang={currentLang} />} />
        <Route path="privacy" element={<Legal type="privacy" lang={currentLang} />} />
        <Route path="terms" element={<Legal type="terms" lang={currentLang} />} />
        <Route path=":slug" element={<Tool lang={currentLang} />} />
        <Route path="*" element={<Navigate to={`/${currentLang}`} replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  useEffect(() => {
    // Initialize Adsense
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { }
  }, []);

  return (
    <Routes>
      <Route path="/:lang/*" element={<LanguageWrapper />} />
      <Route path="/" element={<Navigate to="/en" replace />} />
      <Route path="*" element={<Navigate to="/en" replace />} />
    </Routes>
  );
}